module.exports = __webpack_public_path__ + "dashboard/img/radio_on.2809b0d5020ce53b8382e2fed3beb384.svg";